export default __webpack_public_path__ + "static/media/Modificación-Horario-Junio.418f07ce.jpg";